import { formatCurrency } from "@/lib/utils";

interface AutomatedDiscountRowProps {
  amountCents: number;
}

export function AutomatedDiscountRow({ amountCents }: AutomatedDiscountRowProps) {
  if (amountCents <= 0) return null;

  return (
    <div className="flex justify-between items-center py-1.5">
      <span
        className="text-(--color-text-secondary) truncate pr-2 flex items-center gap-1.5 cursor-help"
        title="A discount automatically applied because your cart meets specific conditions"
      >
        Automated Discount
        <svg
          className="w-3.5 h-3.5 opacity-50"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      </span>
      <span className="text-(--color-success) font-medium tabular-nums shrink-0">
        - {formatCurrency(amountCents)}
      </span>
    </div>
  );
}
